import { render } from "./LeadsPage.vue?vue&type=template&id=3d34af35&scoped=true"
import script from "./LeadsPage.vue?vue&type=script&lang=js"
export * from "./LeadsPage.vue?vue&type=script&lang=js"

import "./LeadsPage.vue?vue&type=style&index=0&id=3d34af35&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d34af35"]])

export default __exports__